import { create } from "zustand";
import {
    POST_SOURCE_TYPE,
    POST_FORM_CONTENT_INPUT,
} from "../../../Components/Post/PostForm/PostFormModal.types";
import { PostType } from "../../../Components/Post/Post.types";

type PostFormModalStoreType = {
    isPostFormModalOpen: boolean;
    postFormOpeningTarget: POST_FORM_CONTENT_INPUT;
    selectedPost: PostType | undefined;
    setIsPostFormModalOpen: (
        open: boolean,
        newOpeningTarget?: POST_FORM_CONTENT_INPUT,
        sourceType?: POST_SOURCE_TYPE,
    ) => void;
    setPostFormOpeningTarget: (
        newOpeningTarget: POST_FORM_CONTENT_INPUT,
    ) => void;
    setSelectedPost: (value?: PostType) => void;
    newPostSourceType?: POST_SOURCE_TYPE;
};

export const usePostFormModalStore = create<PostFormModalStoreType>()(
    (set) => ({
        isPostFormModalOpen: false,
        postFormOpeningTarget: POST_FORM_CONTENT_INPUT.DEFAULT,
        setIsPostFormModalOpen: (
            newOpenState,
            newOpeningTarget = POST_FORM_CONTENT_INPUT.DEFAULT,
            sourceType,
        ) => {
            set({
                isPostFormModalOpen: newOpenState,
                postFormOpeningTarget: newOpeningTarget,
                newPostSourceType: sourceType,
            });
        },
        setPostFormOpeningTarget: (
            newOpeningTarget = POST_FORM_CONTENT_INPUT.DEFAULT,
        ) => {
            set({
                postFormOpeningTarget: newOpeningTarget,
            });
        },
        selectedPost: undefined,
        setSelectedPost: (selectedPost) => {
            set({ selectedPost });
        },
    }),
);
